import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js"

import "./feedback/feedback-manager";
import "./message-manager";

@customElement("page-manager")
export class PageManager extends LitElement {
  static styles = [
    css`
      :host {
        display: contents
      }
    `
  ];

  render() {
    return html`
      <feedback-manager></feedback-manager>
      <message-manager></message-manager>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "page-manager": PageManager;
  }
}
